<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b">Acknowledgments</h2>
<p class="bodytext">A number of libraries, museums, and historical groups provided photographs or information for this book, and I would like to recognize those facilities and organizations. They include the Arkansas History Commission, the Baxter Springs Heritage Museum, the Granby Mining Museum, the Historical Museum for Springfield-Greene County, the Jacksonport State Park, the Jasper County Records Center, the Joplin Public Library, the Kansas Historical Society, the Logan County Historical Museum, the Neosho-Newton County Library, the Pleasant Hill Historical Society, the Springfield-Greene County Library, the State Historical Society of Missouri-Columbia, and the Texas County Historical Society.</p>
<p class="bodytext">I also want to thank certain individuals, some associated with the organizations listed above and some not, who helped me with the book in one way or another. They include Phyllis Abbott, Mark Ballard, Jesse Bellard, Linda Childers, Patty Crane, Dixie Haase, Jim Hounschell, Angela Jackson, Bob Kennedy, Lisa Keys, Scott Mallatt, Larry O’Neal, Jeanne Reynolds, Kathy Richardson, R. J. Savage, Earleene Spaulding, Jason Sullivan, and Steve Weldon.</p>
<p class="bodytext">I also want to thank Pelican editor Nina Kooij for her excellent edit of the manuscript. I know the final product is better because of her input.</p>
<p class="bodytext">As is normally the case with my writing, my wife, Gigi, served as the first reader of many of these stories, and I thank her not only for her proofreading skills but also for her continued support and encouragement.</p>
<p class="pagebreak"></p>
<p class="bodytext"> </p>
<div class="images1"><img alt="images" src="Images/9781589809628_img4.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_9781589809628_Acknowledgments.vue?04ed420b